import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import userProfiler from "web/script/modules/userprofiler";

interface AspirerAcquisitionCampaignControlProps {
    isVisible: boolean;
}

function _AspirerAcquisitionCampaignControl({
    isVisible,
}: AspirerAcquisitionCampaignControlProps): JSX.Element {
    const dispatch = useDispatch();

    useEffect(() => {
        const queryParams = new URL(window.location.href).searchParams;
        if (!userProfiler.isLoggedIn() && queryParams.has("pu") && isVisible) {
            setTimeout(() => {
                dispatch(
                    openCustomerCaptureOverlay({
                        analyticsEventCategory: "aspirer_acquisition_campaign",
                        analyticsEventLabel: "aspirer_editorial_capsule",
                        captureType: "aspirer_acquisition_campaign",
                        componentType: "sign_up",
                        ctaKey: "general.continue",
                        showSocialAuth: false,
                        imageSrc:
                            "https://cdna.lystit.com/static/n/static-img/sign-up-modal/aspirer-acquisition-campaign-modal-image.png",
                        showMarketingCheckbox: false,
                        legalTextKey:
                            // "By creating an account and subscribing to our email communications, you consent to Lyst’s Terms & Conditions and you agree to receive email updates from Lyst.
                            // To learn more about how Lyst uses and protects your personal data, please read Lyst’s Privacy Policy."
                            "account.register.legal_agreement.sign_up_and_subscribe_terms",
                    })
                );
            }, 800);
        }
    }, [dispatch, isVisible]);

    return <div />;
}

export const AspirerAcquisitionCampaignControl = withReduxProvider(
    _AspirerAcquisitionCampaignControl
);
